import * as React from 'react';
import { connect } from 'react-redux';
import { actionCreators } from "../../../store/integration/VSTSStore";
import { ApplicationState } from "../../../store/index";
import { IConnectionsState } from "../../../store/integration/common";
import VSTSConnectionEdit from './VSTSConnectionEdit';
import { SourceType } from '../../../store/ExternalEpmConnectStore';
import BasicAuthConnectionsList from '../BasicAuthConnectionsList';
import { IConnectionInfo } from '../../../entities/Metadata';

type OwnProps = {
    connectionId?: string;
    disabled?: boolean;
    onSelect: (connection: IConnectionInfo) => void;
};

type StateProps = { connections: IConnectionsState; };
type Props = StateProps & typeof actionCreators & OwnProps;

const VSTSConnectionsList = (props: Props) => {
    React.useEffect(() => {
        props.loadConnections();
    }, []);
    return <BasicAuthConnectionsList
        disabled={props.connections.isLoading || !!props.disabled}
        sourceType={SourceType.VSTS}
        connections={props.connections.data}
        onConnectionSelect={props.onSelect}
        onConnectionRemove={props.removeConnection}
        onConnectionRename={props.renameConnection}
        renderAdd={(onCreated: (connectionId: string) => void, onDismiss: () => void) =>
            <VSTSConnectionEdit onCreated={onCreated} onDismiss={onDismiss} />}
        renderEdit={(connectionId: string, onDismiss: () => void) =>
            <VSTSConnectionEdit connectionId={connectionId} onDismiss={onDismiss} />}
    />;
}

function mapStateToProps(state: ApplicationState, ownProps?: OwnProps): StateProps {
    return { connections: state.vsts.connections };
}

export default connect(mapStateToProps, actionCreators)(VSTSConnectionsList);
